var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloneIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "24px",
    viewBox: "0 0 25 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "A52B6CFD-F58A-4F8D-B08F-5416CC6D7859") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TurnItBlue---Milestone-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "13.0_My-Library_02",
    transform: "translate(-1224.000000, -754.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pop-Up-Actions-Copy",
    transform: "translate(1215.000000, 591.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Remove-Copy",
    transform: "translate(9.210526, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Text-Fill-Copy-2",
    transform: "translate(0.000000, 150.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_Left",
    transform: "translate(0.000000, 13.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.08510638,5.54551004 L6.08510638,14.8635809 C6.08510638,16.9935968 7.81632315,18.7272727 9.94331783,18.7272727 L9.94331783,18.7272727 L18.3404255,18.7272727 L18.3404255,20.3181263 C18.3404255,21.6972434 17.2210771,22.8181818 15.8439162,22.8181818 L15.8439162,22.8181818 L4.49650932,22.8181818 C3.11934843,22.8181818 2,21.6972434 2,20.3181263 L2,20.3181263 L2,8.04539905 C2,6.66628196 3.11934843,5.54551004 4.49650932,5.54551004 L4.49650932,5.54551004 L6.08510638,5.54551004 Z M19.4752327,1 C20.8540558,1 21.9715758,2.11910734 21.9715758,3.5000555 L21.9715758,3.5000555 L21.9715758,14.8635809 C21.9715758,16.244529 20.8540558,17.3636364 19.4752327,17.3636364 L19.4752327,17.3636364 L9.94331783,17.3636364 C8.56432847,17.3636364 7.44680851,16.244529 7.44680851,14.8635809 L7.44680851,14.8635809 L7.44680851,3.5000555 C7.44680851,2.11910734 8.56432847,1 9.94331783,1 L9.94331783,1 Z",
    id: "Combined-Shape",
    fill: "currentColor"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloneIcon);
export default __webpack_public_path__ + "static/media/CloneIcon.c6e6bf698c517a887e8c060953725314.svg";
export { ForwardRef as ReactComponent };